import { render, staticRenderFns } from "./cardChangeHistory.vue?vue&type=template&id=fc61a4be&scoped=true"
import script from "./cardChangeHistory.vue?vue&type=script&lang=js"
export * from "./cardChangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc61a4be",
  null
  
)

export default component.exports